import {makeStyles} from '@mui/styles';

const useStyles = makeStyles(() => ({
  headerImage: {
    width: '100%',
  },
}));

export default useStyles;
